<template>
  <!-- Video overlay -->
  <div
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-20 px-4 md:px-12 lg:px-20 py-20 transition-opacity duration-200"
    :class="{
      'visible opacity-100 pointer-events-auto': showOverlay && (youtubeId || src),
      'invisible opacity-0 pointer-events-none': !showOverlay || !(youtubeId || src)
    }"
  >
    <div
      ref="overlay"
      class="w-full max-w-6xl"
    >
      <div
        v-if="showOverlay && (youtubeId || src)"
        class="video-container"
      >
        <youtube-video
          v-if="youtubeId"
          :video-id="youtubeId"
        />
        <Video
          v-else-if="src"
          :model="src"
        />
      </div>
    </div>

    <button
      class="absolute top-0 right-0 transform -translate-x-4 translate-y-4 md:-translate-x-12 md:translate-y-12 w-16 h-16 flex bg-white items-center justify-center rounded-full shadow focus:outline-none focus:bg-primary-light"
      @click="onCloseOverlay($event)"
    >
      <span class="icon-close" />
    </button>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import YoutubeVideo from '@/components/YoutubeVideo.vue'
import Video from '@/components/Video.vue'
import EventBus from '@/event-bus'

export default {
  components: {
    YoutubeVideo,
    Video
  },
  data() {
    return {
      youtubeId: '',
      src: '',
      showOverlay: false
    }
  },
  mounted() {
    EventBus.$on('SHOW_VIDEO_OVERLAY', ({ youtubeId, src }) => {
      this.youtubeId = youtubeId
      this.src = src
      this.showOverlay = true
      disableBodyScroll(this.$refs.overlay)
    })
  },
  methods: {
    onCloseOverlay(e) {
      e.preventDefault()
      enableBodyScroll(this.$refs.overlay)
      this.youtubeId = ''
      this.src = ''
      this.showOverlay = false
    }
  }
}
</script>

<style>
  .video-container {
    @apply relative h-0 overflow-hidden max-w-full pb-9/16;
  }

  .video-container iframe,
  .video-container object,
  .video-container embed {
    @apply absolute top-0 left-0 w-full h-full;
  }
</style>
